import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginService } from './login.service';
import { API_DATA, CLIENT_DATA } from '@frontend/util-api-data';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class LoginServiceJwt implements LoginService {
  private http = inject(HttpClient);

  private apiData = inject(API_DATA);
  client = inject(CLIENT_DATA).name;

  router = inject(Router);
  activatedRoute = inject(ActivatedRoute);

  async login(username: string, password: string): Promise<boolean> {
    try {
      const data = await firstValueFrom(
        this.http
          .post<any>(`${this.apiData.apiURL}${this.client}/login`, { username, password })
          .pipe(catchError(() => of(null)))
      );
      if (data && data.token) {
        localStorage.setItem(`${this.client}token`, data.token);
        window.location.href = this.activatedRoute.snapshot.queryParams['redirectUri'];
        return true;
      }
      return false;
    } catch (error) {
      console.error('Login failed', error);
      return false;
    }
  }

  logout() {
    localStorage.removeItem(`${this.client}token`);
    const currentLang = window.location.pathname.split('/')[1] || '';
    window.location.href = `/${currentLang}`;
  }

  async isLoggedIn(): Promise<boolean> {
    const token = localStorage.getItem(`${this.client}token`);
    if (!token) {
      return false;
    }

    try {
      const payload = jwtDecode(token);

      // exp ist in Sekunden, Date.now() in Millisekunden
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        // Token ist abgelaufen, aus localStorage entfernen
        localStorage.removeItem(`${this.client}token`);
        return false;
      }

      return true;
    } catch (error) {
      console.error('Invalid JWT token', error);
      localStorage.removeItem(`${this.client}token`);
      return false;
    }
  }

  /**
   * Returns decoded JWT token payload.
   *
   * The JWT token should contain these fields for tracking:
   * - country: string (e.g., 'DE', 'FR')
   * - business_partner_type: string (e.g., 'Dealer', 'Contractor')
   * - is_internal_user: string ('true' or 'false')
   *
   * @returns Decoded JWT payload or null if token is invalid
   */
  async getUserInfo() {
    // TODO: #SDC-1240 Temporarily disabled tracking for Jansen and AKS
    return null;

    // const token = localStorage.getItem(`${this.client}token`);
    // if (!token) {
    //   console.warn(`[${this.client}] No JWT token found in localStorage`);
    //   return null;
    // }

    // try {
    //   // JWT besteht aus drei Teilen: Header.Payload.Signature
    //   const payload = JSON.parse(atob(token.split('.')[1]));

    //   console.log(`[${this.client}] JWT Token Payload:`, payload);

    //   // Check if required tracking fields are present
    //   const hasTrackingFields = payload.country && payload.business_partner_type;
    //   if (!hasTrackingFields) {
    //     console.warn(`[${this.client}] JWT token missing tracking fields. Expected: country, business_partner_type, is_internal_user`);
    //     console.warn(`[${this.client}] Current payload keys:`, Object.keys(payload));
    //   }

    //   // Return token payload in format expected by tracking library
    //   // The library expects: { country, business_partner_type, is_internal_user }
    //   return payload;
    // } catch (error) {
    //   console.error(`[${this.client}] Error decoding JWT token for user info:`, error);
    //   return null;
    // }
  }
}
